import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { Plus, Search, Edit2, Trash2, Eye, EyeOff, Building, User, Briefcase } from 'lucide-react';
import { extractCSV, downloadCSV } from "../../../../_helpers";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const LanguisityReport = () => {
  const [reportData, setReportData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/user/linguisity`);
        setReportData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching linguisity report:", error.message);
      }
    };

    fetchData();
  }, []);


  const handleExportCSV = () => {
    downloadCSV(extractCSV());
  };
  const handleDelete = async (ids) => {
    // ids can be a single id or an array of ids
    const idsToDelete = Array.isArray(ids) ? ids : [ids];

    if (!window.confirm(`Are you sure you want to delete ${idsToDelete.length} record(s)?`)) return;

    setLoading(true);
    try {
      if (idsToDelete.length > 1) {
        // Bulk delete endpoint
        await axiosInstance.post(`/request/linguisity/bulk-delete`, { ids: idsToDelete });
      } else {
        // Single delete endpoint
        await axiosInstance.delete(`/request/linguisity/${idsToDelete[0]}`);
      }

      setReportData(prev => prev.filter(t => !idsToDelete.includes(t.id)));
      setSelectedIds([]); // Clear selection after delete
    } catch (error) {
      console.error('Error deleting testimonials:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p> Report For Languisity Subscribers</p>
        <button className="export-btn" onClick={handleExportCSV}>
          Export
        </button>
        {selectedIds.length > 0 && (
          <button
            onClick={() => handleDelete(selectedIds)}
            className="bg-red-500 text-white px-4 py-2 rounded-md mb-3"
          >
            Delete Selected ({selectedIds.length})
          </button>
        )}
      </div>

      <div className="instructor-table">
        {reportData.length === 0 ? (
          <div className="text-center py-12">
            <p className="!text-gray-500 text-lg">No Data Found</p>
          </div>
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedIds(reportData.map(t => t.id));
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                    checked={
                      selectedIds.length > 0 &&
                      selectedIds.length === reportData.length
                    }
                  />
                </th>
                <th>S.no</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {reportData?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(ele.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedIds((prev) => [...prev, ele.id]);
                          } else {
                            setSelectedIds((prev) =>
                              prev.filter(id => id !== ele.id)
                            );
                          }
                        }}
                      />
                    </td>
                    <td className="cell">{index + 1}</td>
                    <td className="cell">{ele.email}</td>
                    <td className="cell">
                      {ele.status ? "Subscribed" : "Unsubscribed"}
                    </td>
                    <td>
                      <button onClick={() => handleDelete(ele.id)}>Delete</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div >
  );
};

export default LanguisityReport;
